import Firebase from './FirebaseAdapter'

export default { Firebase }
